export default __webpack_public_path__ + "static/media/check.99d520c7.png";